import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import menusState from './state';
export const menusSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => menusState);
    },
    initialState: menusState,
    name: 'menus',
    reducers: {
        hideCustomersInfoMenus: {
            prepare: customersInfoMenusIndex => {
                return {
                    payload: {
                        customersInfoMenusIndex
                    }
                };
            },
            reducer: (state, action) => {
                const { customersInfoMenusIndex } = action.payload;
                state.customersInfoMenus = state.customersInfoMenus.filter(item => {
                    return item !== customersInfoMenusIndex;
                });
            }
        },
        hideHamburgerMenu: state => {
            state.hamburgerMenu = false;
        },
        hideLocationsMenu: state => {
            state.locationsMenu = false;
        },
        hideMapFibersMenu: state => {
            state.mapFibersMenu = false;
        },
        hideMapOverlaysMenu: state => {
            state.mapOverlaysMenu = false;
        },
        hideMapSettingsMenu: state => {
            state.mapSettingsMenu = false;
        },
        hideNetworkingMenus: {
            prepare: networkingMenusIndex => {
                return {
                    payload: {
                        networkingMenusIndex
                    }
                };
            },
            reducer: (state, action) => {
                const { networkingMenusIndex } = action.payload;
                state.networkingMenus = state.networkingMenus.filter(item => {
                    return item !== networkingMenusIndex;
                });
            }
        },
        hideUserMenu: state => {
            state.userMenu = false;
        },
        hideUsersMenus: {
            prepare: usersMenusIndex => {
                return {
                    payload: {
                        usersMenusIndex
                    }
                };
            },
            reducer: (state, action) => {
                const { usersMenusIndex } = action.payload;
                state.usersMenus = state.usersMenus.filter(item => {
                    return item !== usersMenusIndex;
                });
            }
        },
        resetMenus: () => menusState,
        resetUsersMenus: state => {
            state.usersMenus = [];
        },
        showCustomersInfoMenus: {
            prepare: customersInfoMenusIndex => {
                return {
                    payload: {
                        customersInfoMenusIndex
                    }
                };
            },
            reducer: (state, action) => {
                const { customersInfoMenusIndex } = action.payload;
                state.customersInfoMenus.push(customersInfoMenusIndex);
            }
        },
        showHamburgerMenu: state => {
            state.hamburgerMenu = true;
        },
        showLocationsMenu: state => {
            state.locationsMenu = true;
        },
        showMapFibersMenu: state => {
            state.mapFibersMenu = true;
            state.mapOverlaysMenu = false;
            state.mapSettingsMenu = false;
        },
        showMapOverlaysMenu: state => {
            state.mapFibersMenu = false;
            state.mapOverlaysMenu = true;
            state.mapSettingsMenu = false;
        },
        showMapSettingsMenu: state => {
            state.mapFibersMenu = false;
            state.mapOverlaysMenu = false;
            state.mapSettingsMenu = true;
        },
        showNetworkingMenus: {
            prepare: networkingMenusIndex => {
                return {
                    payload: {
                        networkingMenusIndex
                    }
                };
            },
            reducer: (state, action) => {
                const { networkingMenusIndex } = action.payload;
                state.networkingMenus.push(networkingMenusIndex);
            }
        },
        showUserMenu: state => {
            state.userMenu = true;
        },
        showUsersMenus: {
            prepare: usersMenusIndex => {
                return {
                    payload: {
                        usersMenusIndex
                    }
                };
            },
            reducer: (state, action) => {
                const { usersMenusIndex } = action.payload;
                state.usersMenus.push(usersMenusIndex);
            }
        }
    }
});
export const { hideCustomersInfoMenus, hideHamburgerMenu, hideLocationsMenu, hideMapFibersMenu, hideMapOverlaysMenu, hideMapSettingsMenu, hideNetworkingMenus, hideUserMenu, hideUsersMenus, resetMenus, resetUsersMenus, showCustomersInfoMenus, showHamburgerMenu, showLocationsMenu, showMapFibersMenu, showMapOverlaysMenu, showMapSettingsMenu, showNetworkingMenus, showUserMenu, showUsersMenus } = menusSlice.actions;
export default menusSlice.reducer;
